module.exports = __webpack_public_path__ + "static/img/home_page.b2a5c49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AmongUs/home_page.png
// module id = hCO2
// module chunks = 1